import tmhRequest from '@/config/tmhRequest'


export default {
    searchListCustomerSourceClassify: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customersourceclassify/searchlistcustomersourceclassify',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/customersourceclassify.js